import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDepartmentsData } from "../../redux/slicer/departmentsSlice";
import { GiGraduateCap } from "react-icons/gi";
import { BiSolidRightArrow, BiSolidDownArrow } from "react-icons/bi";

import CardDeparment from "./Card_department";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import parse from "html-react-parser";
import Preloader from "../../assets/sab.jpeg"; // Preloader image
import DOMPurify from "dompurify"; // Import this at the top if not already




function Deprtment() {
  const navigate = useNavigate();

  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);
  // Extract the query parameter
  const searchParams = new URLSearchParams(location.search);
  const departmentId = searchParams.get("id");

  const dispatch = useDispatch();
  const {
    data: departmentsData,
    loading,
    error,
  } = useSelector((state) => state.departments.departments);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top on component mount

    if (!departmentsData.length) {
      dispatch(fetchDepartmentsData());
    }
  }, [dispatch, departmentsData.length]);

  const department = departmentsData.find(
    (d) => d.department_id === parseInt(departmentId)
  );
  useEffect(() => {
    if (department) {
        console.log("Department found:", department); // Check the entire department object
    }
}, [department]);


  const [isOpen, setIsOpen] = useState(false); // State to track the dropdown visibility

  const toggleDropdown = () => {
    setIsOpen(!isOpen); // Toggle between showing and hiding the content
  };
  const toggleMessage = () => {
    console.log("toggleMessage called");
    setIsExpanded(!isExpanded);
  };

  const truncateMessage = (message, wordLimit) => {
    const words = message.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : message;
  };

  // Strip HTML for word count
const stripHTML = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};

  const safeParse = (html, defaultValue) => {
    if (!html) {
      return defaultValue;
    }

    try {
      const clean = DOMPurify.sanitize(html);
      return parse(clean); // Correctly parse the sanitized HTML
    } catch (e) {
      console.error("Parsing error:", e);
      return defaultValue;
    }
  };



  // if (loading) {
  //   return <div className="text-center text-primary-color">Loading...</div>;
  // }

  // if (error || !department) {
  //   return (
  //     <div className="text-center text-red-600">
  //       Error: {error || "Department not found."}
  //     </div>
  //   );
  // }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (error || !department) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">
          Error: {error || "Department not found."}
        </p>
      </div>
    );
  }
  
  const hodMessage = department?.hod?.hod_message;
  console.log("HOD Message:", hodMessage);

  const plainTextMessage = hodMessage ? stripHTML(hodMessage) : "";
  console.log("Plain Text Message:", plainTextMessage);
  console.log("Plain Text Word Count:", plainTextMessage.split(" ").length);
  
  return (
    <div>
      {/* Hero Section */}
      <div className="relative w-full">
        <div className="overflow-hidden w-full  h-[200px] md:h-[400px]">
          <img
            src={
              "https://tripleseat.com/wp-content/uploads/2022/11/Corporate-Events-6-Strategies-to-Meet-Growing-Demand-and-Drive-Bookings.png"
            }
            alt="carousel-slide"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/4 md:top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-2xl md:text-5xl font-bold font-titillium">
              {department.department_name}
            </h2>
            <p className="text-base md:text-lg mt-4 md:mt-10 bg-img-description  font-titillium"></p>
          </div>
        </div>
      </div>

      {/* Description Section */}
      <div className="px-4 sm:px-8 md:px-28 py-6 mt-6 grid gap-y-6">
        <p className="text-justify text-sm md:text-base font-inter">
        {parse(department.department_description)}
        </p>


        {department.hod && (
          <div className="px-4 sm:px-8 py-6 mt-6">
            <div className="flex flex-col xl:flex-row items-center bg-primary-color rounded-lg p-6 max-w-5xl mx-auto gap-6">
              {/* Image Section */}
              <div className="w-full">
                <img
                  src={department.hod.hod_staff_image_url}
                  alt="HOD"
                  className="object-contain w-full h-64 sm:h-72 md:h-80 lg:h-96 rounded-lg "
                />
              </div>

              {/* Message Section */}
              <div className="text-white w-full mt-4 xl:mt-0 xl:pl-6 relative">
                {/* Added relative positioning to this div */}
                <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-3xl font-bold mb-4 text-left font-titillium">
                  Department Head’s Message
                </h2>
                <div className="flex items-start gap-2 mb-4">
                  <div className="bg-[#3F3F3F] h-2 w-10 rounded-full"></div>
                  <div className="bg-[#3F3F3F] h-2 w-2 rounded-full"></div>
                </div>
                <h2 className="px-8 font-bold text-left font-inter">
                  {safeParse(department.hod.hod_staff_name, "Name Unavailable")}
                </h2>
                {/* Message Content */}
                <p className="text-justify text-sm sm:text-base md:text-base lg:text-lg font-inter mt-2">
                {isExpanded
                  ? safeParse(hodMessage, "Message Unavailable")
                  : safeParse(truncateMessage(plainTextMessage, 120), "Message Unavailable")}
                </p>

                {hodMessage && plainTextMessage.split(" ").length > 120 && (
                  <button
                    onClick={toggleMessage}
                    className="mt-4 text-white font-bold underline absolute bottom-0 right-8" // Added absolute positioning
                  >
                    {isExpanded ? "Read Less" : "Read More"}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Programmes Section */}
        <div className="mt-6 grid gap-y-6">
          <h2 className="text-left text-primary-color text-2xl md:text-4xl  font-titillium">
            Programmes
          </h2>
          <div className="bg-primary-color h-[1px] w-[150px] md:w-[300px] pl-6 "></div>

          {department.programs && department.programs.length > 0 && (
            <div>
              {department.programs.map((program, index) => (
                <div
                  key={index}
                  className="ml-4 md:ml-9 pl-4 md:pl-9 flex items-center space-x-2 mt-3"
                >
                  <div className="text-primary-color text-xl md:text-2xl">
                    <GiGraduateCap />
                  </div>
                  <button
                    className="text-left text-sm md:text-base font-inter"
                    onClick={() =>
                      navigate(`/degree?id=${program.degree_program_id}`)
                    }
                  >
                    <h2 className="text-primary-color text-xl md:text-3xl font-semibold text-left ml-4 md:ml-6 font-inter">
                      {" "}
                      {program.program_name}{" "}
                      {/* Display only the degree name */}
                    </h2>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* HOD Section */}

      {/* Academic Staff Section */}
      <div className="px-4 sm:px-8 md:px-28 py-6 mt-6">
        <h2 className="text-2xl md:text-4xl text-primary-color text-center md:text-left font-titillium">
          Academic Staff
        </h2>
        <div className="bg-primary-color h-[1px] w-[150px] md:w-[300px] pl-6 mt-3"></div>
        <div className="px-4 md:px-0 py-6">
          <CardDeparment departmentsData={departmentsData} />
        </div>
      </div>

      {/* <div className="px-6 pt-4 pb-2 flex justify-end mb-5">
        <button
          onClick={scrollToTop}
          className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-2xl"
        >
          <FaArrowUp />
        </button>
      </div> */}
    </div>
  );
}

export default Deprtment;